import { meeting_attendee_roles } from "../constants/data";

export const isMeetingHost = (meetingAttendeeRole) =>
  meetingAttendeeRole === meeting_attendee_roles.host;
